import { callApi, checkApi } from 'services/config';

export const downloadCheckEmployeePaystub = async ({
  employeeID,
  payrollID,
  theraCompanyID,
}: {
  employeeID: string;
  payrollID: string;
  theraCompanyID: string;
}) => {
  const url = `/services/check/employees/${employeeID}/paystubs/${payrollID}`;
  return await callApi(url, 'GET', {}, true, theraCompanyID);
};

export const downloadCheckEmployeeDocument = async ({
  documentID,
  theraCompanyID,
}: {
  documentID: string;
  theraCompanyID: string;
}) => {
  const url = `/services/check/documents/employee_tax_documents/${documentID}/download`;
  return await callApi(url, 'GET', {}, true, theraCompanyID);
};

export const getCheckEmployee = async ({ employeeID, theraCompanyID }) => {
  const url = `/services/check/employees/${employeeID}`;
  return await callApi(url, 'GET', {}, false, theraCompanyID);
};

export const validateUSAddress = async ({
  street1,
  street2 = '',
  city,
  state,
  zip,
}: {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zip: string;
}) => {
  const url = `/addresses/validate`;
  try {
    const response = await checkApi({
      url: `?checkUrl=${url}`,
      method: 'POST',
      data: { line1: street1, line2: street2, city, state, postal_code: zip, country: 'US' },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Failed to validate address',
    };
  }
};

export const downloadCheckCompanyAuthorizationDocument = async ({
  documentID,
  theraCompanyID,
}: {
  documentID: string;
  theraCompanyID: string;
}) => {
  const url = `/services/check/documents/company_authorization_documents/${documentID}/download`;
  return await callApi(url, 'GET', {}, true, theraCompanyID);
};

export const downloadCheckCompanyTaxDocument = async ({
  documentID,
  theraCompanyID,
}: {
  documentID: string;
  theraCompanyID: string;
}) => {
  const url = `/services/check/documents/company_tax_documents/${documentID}/download`;
  return await callApi(url, 'GET', {}, true, theraCompanyID);
};
